import videoImg from '../../images/plane-drone.png'
import articleImg from '../../images/drone.png'
import caseStudy from '../../images/detection.png'
import '../../styles/blog.css'

const BlogData = [
    {
        imgUrl: videoImg,
        title: 'Quantum gradiometer sensor',
        desc: "Precisely detects tiny variations in Earth's magnetic field. Tracking the progress of a small-sized threat",
        linkUrl: 'https://www.youtube.com/watch?v=9fa9lVwHHqg'
    },
    {
        imgUrl: articleImg,
        title: 'Diagnostics',
        desc: "Dedicated algorithms and Edge AI through smartphone and extended AI cloud computing",
        linkUrl: 'https://www.youtube.com/watch?v=9fa9lVwHHqg'
    },
    {
        imgUrl: caseStudy,
        title: 'Magnetically shielded environment',
        desc: 'No shielded chamber required. Uses built-in adaptive shielding',
        linkUrl: 'https://www.youtube.com/watch?v=9fa9lVwHHqg'
    },
]

export default function Blog() {
  return (
    <section id='projects' className='blog'>
      <div className="container">
        <div className="blog_top-content">
          <h2>
            Our <span className="highlight">Solution</span>
          </h2>
          <p className="subtitle">
            High sensitivity of short/near field sensor to approaching small-scale threats 
            and dealing with environmental noise interference
          </p>
        </div>
        
        <div className="blog_wrapper">
          {BlogData.map((item, index) => (
            <article className="blog_item" key={index}>
              <div className="blog_item-inner">
                <div className="blog_img">
                  <img src={item.imgUrl} alt={item.title} loading="lazy" />
                  <div className="blog_img-overlay"></div>
                </div>
                
                <div className="blog_content">
                  <h3>{item.title}</h3>
                  <p className="description blog_desc">{item.desc}</p>
                  
                  <a 
                    href={item.linkUrl} 
                    target='_blank' 
                    rel='noreferrer noopener' 
                    className="learn_more"
                    aria-label={`Learn more about ${item.title}`}
                  >
                    <span>Learn more</span>
                    <i className='ri-arrow-right-line'></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}